import React from 'react';
import '../styles/Careers.css'; // Import the CSS file
import CareerSection from "./CareerSection";
import JobSection from "./JobSection";
import JobCard from "./JobCard";
import WhyJoinSection from "./WhyJoinSection";


const Careers = () => {
  return (
    <div className="careers-container">
      <CareerSection />
      <JobSection />
      <JobCard />
      <WhyJoinSection />
    </div>
  );
};

export default Careers;
